export enum PublicatieStatus {
  Gepubliceerd = 'GEPUBLICEERD',
  NietGepubliceerd = 'NIET_GEPUBLICEERD',
  Afgesloten = 'AFGESLOTEN'
}
